module.exports = __webpack_public_path__ + "img/ESBE_1550.0d3815a1.png";